<template>
    <div class="imageIdentify" v-loading="loading" element-loading-text="正在加载中">
        <div class="top">
            <changeName></changeName>
            <imageName></imageName>
        </div>
        <div class="contentBill">
            <!-- true 不允许更换单证 -->
            <template v-if="$route.query.status === 'true'">
                <div class="upload-demo">
                    <el-button size="small" class="cancel" type="white disable"
                        style="height:42px;line-height: 42px;">更换模板文件</el-button>
                </div>
            </template>
            <template v-else>
                <UploadFile></UploadFile>
            </template>
            <div class="toTest">
                <el-button size="small" type="test" @click="testTemplate">测试模板</el-button>
            </div>
            <bl-drag :id="bgDragId" :draggable="false">
                <div slot="left-content" class="left">
                    <ImageDocRender v-loading="areaLoading" ref="imageRender"></ImageDocRender>
                </div>
                <div slot="right-content" class="right" id="rightSroll">
                    <el-tabs v-model="activeName" @tab-click="tabClick" class="tabsTop">
                        <el-tab-pane :lazy="true" name="first" key="first">
                            <span slot="label"><em>1</em>单证分类配置</span>
                        </el-tab-pane>
                        <el-tab-pane :lazy="true" name="second" key="second">
                            <span slot="label"><em>2</em>配置单证字段</span>
                        </el-tab-pane>
                        <el-tab-pane :lazy="true" name="three" key="three">
                            <span slot="label"><em>3</em>配置字段分组</span>
                        </el-tab-pane>
                        <el-tab-pane :label="editType === null? 'OCR识别结果':'文件解析结果'" :lazy="true" name="third"
                            key="third">
                            <span slot="label"><em>4</em>{{editType === null? 'OCR识别结果':'文件解析结果'}}</span>
                        </el-tab-pane>
                    </el-tabs>
                    <!-- first 配置单证类型标识 -->
                    <keep-alive>
                        <DocType v-if="activeName ==='first'" :onlyRead="$route.query.status === 'true'"></DocType>
                        <!-- second 配置单证字段 -->
                        <DocFields v-if="activeName ==='second'" :mainInfo="mainInfo" @on-delete="deleteSuccess"
                            ref="editTexts"></DocFields>
                        <!-- three 配置字段分组 -->
                        <DocGroup v-if="activeName ==='three'" :mainInfo="mainInfo"></DocGroup>
                        <!-- third OCR识别结果 -->
                        <ocrResult v-if="activeName ==='third'"></ocrResult>
                    </keep-alive>
                </div>
            </bl-drag>
        </div>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    import _ from 'lodash'

    import UploadFile from './UploadFile'
    import ImageDocRender from './ImageDocRender'
    import BlDrag from '../common/bl-dragConf'
    import changeName from '../common/changeName'
    import imageName from '../common/imageName'
    import ocrResult from '../common/ocrResultConf'
    import DocFields from './DocFields'
    import DocType from './DocType'
    import DocGroup from './DocGroup'

    export default {
        name: 'editContent',
        mixins: [],
        props: {},
        data() {
            return {
                mainInfo: [],
                bgDragId: '',
                subTypeRule: {},
                loading: false,
                areaLoading: false
            }
        },
        computed: {
            ...mapState(['labelState']),
            ...mapGetters(['editTemplate', 'editType', 'tabOCRName']),
            activeName: {
                get() {
                    return this.$store.state.labelState.editpageTab
                },
                set() { }
            }
        },
        watch: {
            editTemplate(val) {
                if (val) {
                    //console.log(val, 999999123123)
                    /*
                     *   category: "df"  默认单证类型-默认为创建模板名字，修改命名后为subTypeRule.category
                     *   imageList: Array 图片列表
                     *   ruleMap: Object，规则
                     *   subTypeRule: Object 单证分类配置
                     *   templateId: "5fbf9c36f24250199f022f66" 模板id
                     */

                    // this.subTypeRule = val.subTypeRule;

                    this.$nextTick().then(() => this.setData(val))
                }
            }
        },
        mounted() { },
        updated() { },
        beforeDestroy() {
            //清除滚动位置 DocFields.vue
            localStorage.removeItem('BL_ORIGIN_TEMPLATE_EDITTEXTSCROLL')

            //清除折叠位置 editCollapse.vue
            localStorage.removeItem('BL_ORIGIN_TEMPLATE_COLLAPSE')
        },
        methods: {
            deleteSuccess(x) {
                let index = this.mainInfo.findIndex(item => {
                    return item[0] === x
                })
                this.mainInfo.splice(index, 1)
            },
            setData(val) {
                // 改造mainInfo，=>DocFields.vue=>editCollapse.vue引入
                let entries = Object.entries(val.ruleMap)
                entries.forEach(item => {
                    // 获取规则
                    // console.log(item)

                    // item[0]：存储字段名

                    // item[1]：存储编辑规则内容-与默认值合并
                    //初始化后端表单undefined的属性
                    if (item[1]['fieldRuleList'].length === 0) {
                        let x = _.cloneDeep(this.$utils.defaultRule)
                        x.name = item[0]
                        item[1]['fieldRuleList'] = [x]
                    } else {
                        item[1]['fieldRuleList'].forEach(x => {
                            x = _.defaults(x, this.$utils.defaultRule)
                        })
                        item[1]['fieldRuleList'] = _.cloneDeep(item[1]['fieldRuleList'])
                    }

                    // 筛选规则
                    let fieldFilterRule = _.defaults(
                        item[1]['fieldFilterRule'],
                        this.$utils.defaultFilterRule
                    )

                    item[1]['fieldFilterRule'] = _.cloneDeep(fieldFilterRule)

                    //item[2]：存储新增tabs属性
                    item.push({
                        _editableTabs: [],
                        _editableTabsValue: '1', //tabs,v-model
                        _tablen: item[1]['fieldRuleList'].length //tabs长度
                    })

                    //item[2]：_editableTabs新增属性
                    item[1]['fieldRuleList'].forEach((x, i) => {
                        /*
                         * title: '规则1',饿了吗组件字段
                         * name: '1',饿了吗组件字段
                         * validator: true 校验
                         *
                         */
                        let obj = {}
                        obj.result = true
                        obj.validator = true

                        //tab属性
                        let num = i + 1
                        obj.title = '规则' + num
                        obj.name = '' + num

                        item[2]['_editableTabs'].push(obj)
                    })

                    //item[3]：新增测试，存储抽取结果属性
                    item.push({
                        _edited: false, // 折叠开关，true代表当前折叠展开
                        _huoqu: true, // 折叠开关，true代表值的获取展开
                        _shaixuan: false, // 折叠开关，true代表值的筛选展开
                        _testShow: false, //结果展示开关
                        _testWord: '', //测试结果：单值，rectangle字段赋值
                        _rectangleList: [], //测试结果，多值，rectangleList字段赋值
                        _sourceData: [] //抽取结果，sourceData字段赋值
                    })
                })
                this.mainInfo = _.cloneDeep(entries)
                //console.log(this.mainInfo)
            },
            tabClick(tabInstance) {
                //tab切换后，自动定位到当前正在配置的字段
                let editScroll = this.$utils.storage('BL_ORIGIN_TEMPLATE_EDITTEXTSCROLL')
                if (tabInstance.name === 'second' && editScroll) {
                    //切换到第二个tab,先展开collage,然后延时滚动
                    // setTimeout(() => {
                    //     let editTexts = document.querySelector('.editTexts');
                    //     if (editTexts) {
                    //         editTexts.scrollTop = editScroll;
                    //     }
                    // }, 500)
                }

                // 当前tab名为原文件，清空标注框及文字
                if (this.tabOCRName === '原文件') {
                    this.$text && this.$text.setData([])
                    this.$polygon && this.$polygon.setData([])
                }
                this.$store.dispatch('setEditpageTab', tabInstance.name)
            },
            testTemplate() {
                let id = this.$route.query.id
                let url = this.$resource.getTemplateInfo.replace('{id}', id)

                this.$axios({
                    // url: 'http://localhost:8080/data.json',
                    url: url,
                    method: 'get'
                })
                    .then(res => {
                        let data = res.data.data

                        // 校验
                        // if (data.subTypeRule && data.subTypeRule.subMatchWords.length > 0) {
                        let query = this.$route.query

                        this.$router.push({
                            path: '/dashboard/template/testpage',
                            query: {
                                id: query.id,
                                name: query.name,
                                ruleId: query.ruleId,
                                from: this.$route.name,
                                category: query.category,
                                status: String(this.$route.query.status),
                                certiType: this.$route.query.certiType
                            }
                        })
                        // } else {
                        //     this.$message.error('单证类型标识未配置');
                        // }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
        components: {
            BlDrag,
            changeName,
            UploadFile,
            ImageDocRender,
            ocrResult,
            DocType,
            DocFields,
            imageName,
            DocGroup
        }
    }
</script>
<style>
    #rightSroll {
        .el-tabs__item {
            em {
                background: #f1f8ff;
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #8399c4;
                border-radius: 50%;
                display: inline-block;
                text-align: center;
                font-size: 12px;
                margin-right: 10px;
            }
        }

        .el-tabs__item.is-active {
            em {
                background: #4580fe;
                width: 18px;
                height: 18px;
                line-height: 18px;
                color: #fff;
                border-radius: 50%;
                display: inline-block;
                text-align: center;
                font-size: 12px;
                margin-right: 10px;
            }
        }
    }

    #tab-second {
        /* border-right: 1px solid #eee; */
    }

    #tab-third {
        /* padding-left: 50px; */
    }
</style>